'use client';

import { useLayoutEffect, useRef, useState } from 'react';

export default function useElementWidth<T extends HTMLElement = HTMLElement>() {
    const ref = useRef<T>(null);
    const [width, setWidth] = useState<number | null>(null);
    useLayoutEffect(() => {
        if (ref.current === null) return;

        setWidth(ref.current.offsetWidth);
    }, []);

    return [ref, width] as const;
}
